module.exports = __webpack_public_path__ + "static/media/circle-check-ok.7fc9d9f5.png";